import { InjectionToken } from '@angular/core';

export const USER_AGENT = new InjectionToken<string>('USER_AGENT');
